import { useEffect, useState, useRef } from "react";
import {
  doc,
  onSnapshot,
  collection,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../../firebase/firebase";

function ReadOnlyPitch({ founderId }) {
  const [pitch, setPitch] = useState(null);

  // 🔒 Dedupe guard (log only once per session)
  const loggedOpen = useRef(false);

  useEffect(() => {
    const unsub = onSnapshot(doc(db, "pitches", founderId), (snap) => {
      setPitch(snap.exists() ? snap.data() : null);
    });

    return () => unsub();
  }, [founderId]);

  const handleOpenPitch = async () => {
    if (loggedOpen.current) return;
    loggedOpen.current = true;

    try {
      await addDoc(collection(db, "analytics"), {
        ownerId: founderId,
        eventType: "pitch_open",
        source: "evaluator",
        entityType: "pitch",
        timestamp: serverTimestamp(),
        userAgent: navigator.userAgent,
      });
    } catch {
      // silent fail — analytics should never break UX
    }
  };

  return (
    <div className="card" style={{ padding: 24, marginBottom: 24 }}>
      <h3>Pitch</h3>

      {!pitch ? (
        <p>No pitch uploaded.</p>
      ) : (
        <>
          <p>
            <strong>{pitch.currentFileName}</strong>
          </p>

          <a
            href={pitch.currentFileUrl}
            target="_blank"
            rel="noreferrer"
            className="btn-primary"
            onClick={handleOpenPitch}
          >
            View / Download Pitch
          </a>
        </>
      )}
    </div>
  );
}

export default ReadOnlyPitch;
